import { CanActivateChildFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { ApiService } from '../services/api.service'
import { map, take } from 'rxjs'
import { MenuItem } from '../interfaces/api/MenuItem'
import { MenuItemType } from '../interfaces/api/MenuItemType'
import { ContractType } from '../interfaces/contract-type'
import { environment } from '../../environments/environment'
import { MenuService } from '../services/menu.service'


export const contractSignedGuard: CanActivateChildFn = (childRoute, state) => {
    const api = inject(ApiService)
    const router = inject(Router)
    const menuService = inject(MenuService)

    if (state.url === '/login-error') return true
    if (state.url.startsWith('/login')) return true

    const contract: ContractType = childRoute.data['contract']

    const alreadySigned = sessionStorage.getItem('is-' + contract + '-signed')
    if(alreadySigned) {
        return true;
    }

    return api.getContractInfo(contract).pipe(
        take(1),
        map(signedContract => {
            if(signedContract.isSigned){
                sessionStorage.setItem('is-' + contract + '-signed', 'true')
                return true;
            }

            if(environment.webComponent){
                menuService.goTo({type: MenuItemType.LINK, code: '', link: environment.frontEndUrl + state.url}, true)
                return false;
            }

            const menuItems = api.userInfo.getValue().mainMenu.items
            const otherItems = api.userInfo.getValue().otherServicesMenu.items

            const item: MenuItem | undefined =
                menuItems.find((item) => item.requiresContract === contract) ||
                otherItems.find((item) => item.requiresContract === contract)

            if(!item){
                console.error('No menu item found that needs the contract', contract)
                router.navigate([''])
                return false;
            }

            router.navigate(['sign-contract', contract], {skipLocationChange: true, state: {link: item}})
            return false
        })
    )
}
